<template>
  <form>
    <h2 class="text-primary">Store Builder</h2>
    <p>Tell us how you will use your site.</p>
    <FormMessage :errors="errors" v-if="errors" />

    <div class="" v-if="requireStoreBuilder">
      <StoreBuilderForm @success="next" @back="back" />
    </div>

    <!-- <div class="mt-4 text-right">
      <Btn class="mr-2" variant="light" :disabled="loading" @click="back">
        {{ $t("global.back") }}
      </Btn>
      <Btn variant="primary" type="submit" :loading="loading" @click="next">
        {{ $t("global.next") }}
      </Btn>
    </div> -->
  </form>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
// import Btn from "@/components/display/Btn";
// import FormCheckbox from "@/components/display/form/FormCheckbox";
// import FormInput from "@/components/display/form/FormInput";
// import FormSelect from "@/components/display/form/FormSelect";
// import { checkoutPlanDetails as planDetailsValidationRules } from "leatherman-js/utils/validations/forms";
import store from "@/store";
import StoreBuilderForm from "@/components/smart/forms/StoreBuilderForm";
// import useValidator from "@/utils/useValidator";

export default {
  name: "CheckoutDetailsPage",
  components: {
    // Btn,
    // FormCheckbox,
    // FormInput,
    // FormSelect,
    StoreBuilderForm,
  },
  setup(props, context) {
    const loading = ref(false);
    const errors = ref(null);

    const requireStoreBuilder = computed(() => store.getters["checkout/requireStoreBuilder"]);

    const back = () => {
      context.root.$router.push({
        name: "checkout-free-trial-details",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    const next = () => {
      // loading.value = true;
      store.dispatch("checkout/setStoreBuilderId", 9999);
      errors.value = null;
      context.root.$router.push({
        name: "checkout-free-trial-profile",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    onMounted(() => {
      if (!store.state.checkout.appId || !store.state.checkout.packageId) {
        back();
      } else {
        store.dispatch("checkout/autoRedirect", false);
      }
    });

    return {
      next,
      back,
      errors,
      loading,
      requireStoreBuilder,
    };
  },
};
</script>
